module.exports = __webpack_public_path__ + "static/media/twitter.c6be540c.svg";